import { map } from "rxjs/operators";
export function mapButtonDisabled() {
    return (source) => source.pipe(map(([disabled, activeIndeterminateProgress, loading]) => {
        return (disabled ||
            activeIndeterminateProgress ||
            (loading > 0 && loading < 100));
    }));
}
